import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import polyglotI18nProvider from "ra-i18n-polyglot";
import germanMessages from "./infrastructure/germanMessages.ts";
import type { TranslationMessages } from "react-admin";
import "./index.css";
import App from "./App.tsx";
import { createContainer } from "@infra/di/AppContainer.ts";
import { DIProvider } from "@infra/di/react.tsx";
import { logamiTheme } from "./adapters/inbound/layout/LogamiTheme.ts";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { CssBaseline } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const container = createContainer();
const queryClient = new QueryClient();

const messages: Record<string, TranslationMessages> = {
  de: germanMessages,
};

const i18nProvider = polyglotI18nProvider(
  (locale: string) => messages[locale] ?? messages.de,
  "de",
);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <DIProvider value={container}>
        <ThemeProvider theme={logamiTheme}>
          <CssBaseline/>
          <QueryClientProvider client={queryClient}>
            <App i18nProvider={i18nProvider} />
          </QueryClientProvider>
        </ThemeProvider>
      </DIProvider>
    </BrowserRouter>
  </StrictMode>,
);
